import React from "react";
import "./index.css";
import { useState } from "react";

import illustrateImgBefore from "../../images/Illustration-before.png";
import illustrateImgAfter from "../../images/Illustration-after.png";

import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";

const points = [
  {
    id: "#1",
    text: "We don’t just talk about results — we deliver them. We track key metrics and provide regular reporting to demonstrate the impact of our work.",
  },
  {
    id: "#2",
    text: "We believe in building strong partnerships with our clients. We take the time to understand your business and develop customized solutions that meet your specific needs.",
  },
  {
    id: "#3",
    text: "We’re constantly exploring new technologies and strategies to ensure that our clients stay ahead of the curve. We’re not afraid to experiment and push the boundaries of what’s possible.",
  },
  {
    id: "#4",
    text: "We believe in transparent pricing. We provide detailed quotes upfront, so you’re never surprised by hidden fees or unexpected costs.",
  },
];

const SuccessSection = () => {
  const [imageSrc, setImageSrc] = useState(illustrateImgBefore);
  return (
    <Box
      sx={{
        // backgroundColor: "#000",
        color: "white",
        padding: "2rem 0",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            marginBottom: "20px",
            color: "white",
            textAlign: "center",
          }}
        >
          Your Success is Our Priority
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginBottom: "30px", color: "white", textAlign: "center" }}
        >
          In today’s fast-changing digital world, innovation is not just a buzzword — it’s the way we work.
          Europa Solutions is your gateway to unlimited online opportunities. As a trusted website development company and digital marketing agency, we set new benchmarks instead of just keeping up.

        </Typography>
        <div className="row p-1">
          <div className="col-lg-3 col-sm-12 success-card">
            {points.slice(0, 2).map((point, index) => (
              <div className="custom-card" key={index}>
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    {point.id}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#fff" }}>
                    {point.text}
                  </Typography>
                </CardContent>
              </div>
            ))}
          </div>
          <div className="col-md-12 col-lg-6 col-sm-12 success-card-rocket">
            <img
              className="illustration-image"
              src={imageSrc}
              alt="Rocket Image"
              style={{
                width: "100%",
                objectFit: "contain",
                transition: "0.3s ease-in-out",
              }}
            />
          </div>
          <div className="col-lg-3 col-sm-12 success-card">
            {points.slice(2).map((point, index) => (
              <div key={index} className="custom-card">
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    {point.id}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#fff" }}>
                    {point.text}
                  </Typography>
                </CardContent>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Box>
  );
};

export default SuccessSection;
